module.exports = __webpack_public_path__ + "img/Tablet - 64.2611fd05.png";